import DisplayPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/boxAnnotation/components/BoxAnnotationDisplayPart';
import FormPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/boxAnnotation/components/BoxAnnotationFormPart';

const exported = {
  DisplayPart,
  FormPart,
};

export default exported;
export { DisplayPart, FormPart };
